<template>
    <div class="cta-block-module"
         :class="{fadeInUp: isVisible}"
         v-observe-visibility="{
                callback: visibilityChanged,
                throttle: 300,
                intersection: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: 0
                }
           }">
        <div class="block-wrapper">
            <wp-image :image="background_image"
                      :is-background="true"
                      class="background">
            </wp-image>
        </div>
        <div class="content-container">
            <content-block  v-bind="content"/>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../utils/EventBus'
    import ContentBlock from './components/ContentBlock'

    export default {
        name: "ctaBlockModule",
        components: { ContentBlock },
        props: {
            background_image: [Boolean, Object],
            content: Object,
        },
        data() {
            return {
                isVisible: false
            }
        },
        methods: {
            visibilityChanged(isVisible) {
                if (EventBus.pageLoaded && !this.isVisible) this.isVisible = isVisible
            },
        },
        watch: {
            $route: {
                deep: true,
                immediate: true,
                handler(val, oldVal) {
                    this.isVisible = false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    // Fade In Up
    .fadeInUp {
        animation-duration: 1s;
        animation-fill-mode: both;
        -webkit-animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        -webkit-animation-name: fadeInUp;
        animation-name: fadeInUp;
    }
    @-webkit-keyframes fadeInUp {
        from {
            transform: translate3d(0,100px,0)
        }
        to {
            transform: translate3d(0,0,0);
            opacity: 1
        }
    }
    @keyframes fadeInUp {
        from {
            transform: translate3d(0,100px,0)
        }

        to {
            transform: translate3d(0,0,0);
            opacity: 1
        }
    }

    .cta-block-module {
        opacity: 0;
        position: relative;
        width: 100%;
        min-height: 1000px;
        margin: 0 auto;
        @include site-container;

        @media (min-width: $bp-medium) {
            margin-top: -150px;
            width: 90%;
            height: 80vh;
            min-height: 850px;
        }
    }

    .block-wrapper {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -22;
    }

    .background {
        position: relative;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: right;
        width: 100%;
        height: 100%;
    }

    .content-container {
        position: absolute;
        bottom: 40px;
        right: 20px;
        left: 20px;
        margin: 0;
        background-color: $white;
        max-width: 500px;

        /deep/ .content-block {
            padding: 0 30px;
        }

        @media (min-width: $bp-medium) {
            top: 50px;
            left: 50px;
            bottom: 50px;
            margin: 0 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            /deep/ .content-block {
                padding: 0 60px;
            }
        }
    }
    
</style>